module.exports = __webpack_public_path__ + "static/media/grace.428e1eb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/grace.jpg
// module id = 407
// module chunks = 0